/**
 * Reading the CSRF token back out of its cookie.
 *
 * The session cookie is httpOnly and deliberately unreadable here. The CSRF
 * cookie is the opposite — it is issued readable precisely so the console can
 * copy it into `X-CSRF-Token`, which is the half of the double-submit pair a
 * cross-site page cannot produce. See `apps/api/src/middleware/csrf.ts`.
 */

/** Matches `DEFAULT_CSRF_COOKIE` in the API. */
export const CSRF_COOKIE = 'cb_csrf'

export function readCookie(name: string): string | undefined {
  if (typeof document === 'undefined') return undefined
  const prefix = `${name}=`
  for (const part of document.cookie.split('; ')) {
    if (part.startsWith(prefix)) return decodeURIComponent(part.slice(prefix.length))
  }
  return undefined
}
